var BufferContextMenuView = require('buffercontextmenuview');


var ChildContextMenuView = BufferContextMenuView.extend({
    events: $.extend({}, BufferContextMenuView.prototype.events, {
        'buttonClick button.hide': 'clickHide',
        'buttonClick button.show': 'clickShow',
        'buttonClick button.joinpart': 'clickJoinPart',
        'buttonClick button.joinpartcollapse': 'clickJoinPartCollapse',
        'buttonClick button.replyCollapse': 'clickReplyCollapse',
        'buttonClick button.replyQuote': 'clickReplyQuote',
        'buttonClick button.typing': 'clickTyping',
        'buttonClick button.files': 'clickFiles',
        'buttonClick button.attachments': 'clickAttachments',
        'buttonClick button.images': 'clickImages',
        'buttonClick button.pastes': 'clickPastes',
        'buttonClick button.socialMedia': 'clickSocialMedia',
        'buttonClick button.mastodon': 'clickMastodon',
        'buttonClick button.bsky': 'clickBsky',
        'buttonClick button.reddit': 'clickReddit',
        'buttonClick button.pinned': 'clickPinned'
    }),
    clickHide: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.archive();
        this.clearContext();
    },
    clickShow: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.unarchive();
        this.clearContext();
    },
    clickJoinPart: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setShowingJoinPartPref(!this.buffer.isShowingJoinPart());
        this.clearContext();
    },
    clickJoinPartCollapse: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setCollapsingJoinPartPref(!this.buffer.isCollapsingJoinPart());
        this.clearContext();
    },
    clickReplyCollapse: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setCollapsingRepliesPref(!this.buffer.isCollapsingReplies());
        this.clearContext();
    },
    clickReplyQuote: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setQuoteRepliesPref(!this.buffer.isShowingQuoteReplies());
        this.clearContext();
    },
    clickTyping: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setTypingStatusPref(!this.buffer.isSharingTyping());
        this.clearContext();
    },
    clickFiles: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlineFilesPref(!this.buffer.inlineFilesAllowed());
        this.clearContext();
    },
    clickAttachments: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlineAttachmentsPref(!this.buffer.inlineAttachmentsAllowed());
        this.clearContext();
    },
    clickImages: function (e) {
        e.preventDefault();
        this.hide();
        if (this.buffer.inlineImagesAllowed()) {
            this.buffer.disableInlineImages();
        } else if (this.buffer.session.getPref('inlineimagewarn')) {
            this.buffer.enableInlineImages();
        } else {
            this.buffer.trigger('inlineImageConfirm');
        }
        this.clearContext();
    },
    clickPastes: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlinePastesPref(!this.buffer.inlinePastesAllowed());
        this.clearContext();
    },
    clickSocialMedia: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlineSocialMediaPref(!this.buffer.inlineSocialMediaAllowed());
        this.clearContext();
    },
    clickMastodon: function (e) {
        e.preventDefault();
        this.hide();
        if (this.buffer.inlineMastodonAllowed()) {
            this.buffer.setInlineMastodonPref(false);
        } else if (this.buffer.session.getPref('inlinemastodonwarn')) {
            this.buffer.setInlineMastodonPref(true);
        } else {
            this.buffer.trigger('inlineMastodonConfirm');
        }
        this.clearContext();
    },
    clickBsky: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlineBskyPref(!this.buffer.inlineBskyAllowed());
        this.clearContext();
    },
    clickReddit: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlineRedditPref(!this.buffer.inlineRedditAllowed());
        this.clearContext();
    },
    clickPinned: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setPinned(!this.buffer.isPinned());
        this.clearContext();
    },
    onShow: function () {
        // Archived
        this.deactivateItem(this.$('li.show'), !this.buffer.isArchived(), true);
        this.deactivateItem(this.$('li.hide'), this.buffer.isArchived(), true);

        // Replies
        this.deactivateItem(this.$('li.replyCollapse'), !this.buffer.connection.hasReliableClientTags(), true);
        this.deactivateItem(this.$('li.replyQuote'), !this.buffer.connection.hasReliableClientTags(), true);
        this.enableItem(this.$('li.replyCollapse'), this.buffer.isCollapsingReplies());
        this.enableItem(this.$('li.replyQuote'), this.buffer.isShowingQuoteReplies());

        // Typing indicators
        this.deactivateItem(this.$('li.typing'), !this.buffer.connection.hasClientTags(), true);
        this.enableItem(this.$('li.typing'), this.buffer.isSharingTyping());
        
        // Showing join parts
        this.deactivateItem(this.$('li.collapseJoinPart'), !this.buffer.isShowingJoinPart(), true);
        this.enableItem(this.$('li.showJoinPart'), this.buffer.isShowingJoinPart());
        this.enableItem(this.$('li.collapseJoinPart'), this.buffer.isCollapsingJoinPart());
        
        // Embeds
        this.enableItem(this.$('li.inlineFiles'), this.buffer.inlineFilesAllowed());
        this.deactivateItem(this.$('li.inlineAttachments'), !this.buffer.connection.hasReliableClientTags(), true);
        this.enableItem(this.$('li.inlineAttachments'), this.buffer.inlineAttachmentsAllowed());
        this.enableItem(this.$('li.inlineImages'), this.buffer.inlineImagesAllowed());
        this.enableItem(this.$('li.inlinePastes'), this.buffer.inlinePastesAllowed());
        this.enableItem(this.$('li.inlineSocialMedia'), this.buffer.inlineSocialMediaAllowed());
        this.enableItem(this.$('li.inlineMastodon'), this.buffer.inlineMastodonAllowed());
        this.enableItem(this.$('li.inlineBsky'), this.buffer.inlineBskyAllowed());
        this.enableItem(this.$('li.inlineReddit'), this.buffer.inlineRedditAllowed());

        // Pinned buffers

        this.deactivateItem(this.$('li.pinned'), !this.buffer.canPin(), true);
        this.enableItem(this.$('li.pinned'), this.buffer.isPinned());
    }
});


module.exports = ChildContextMenuView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/childcontextmenuview.js
// module id = SbjP
// module chunks = 1